import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'admin-match-day-list',
    templateUrl: 'match-day-list.page.html',
    styleUrls: ['../../../../layouts/admin/admin.layout.scss', 'match-day-list.page.scss'],
})
export class AdminMatchDayListPage implements OnInit {
    ngOnInit(): void {

    }
}